module.exports = __webpack_public_path__ + "img/bn-popup-line-2.932435ac.png";